import NumberFormatter from './components/NumberFormatter/NumberFormatter'

// TODO: Add info about component (Marek Prantl)

const Money = ({ amount, currency, emptyValue = '-', valueStyle, currencyStyle }) => {
    return (
        <span className={'money'}>
            <NumberFormatter
                customBase={1}
                value={amount}
                emptyValue={emptyValue}
                currency={currency}
                decimalPlaces={0}
                showUnits={false}
                showCurrency
                valueStyle={valueStyle}
                currencyStyle={currencyStyle}
            />
        </span>
    )
}

export default Money
